export interface Announcement {
  version: string;
  date: string;
  title: string;
  features: {
    title: string;
    description: string;
    icon?: string;
  }[];
}

export const announcements: Announcement[] = [
  {
    version: "2.1.0",
    date: "2025-11-25",
    title: "Enhanced User Experience",
    features: [
      {
        title: "Profile Dropdown",
        description: "Quick access to your profile, settings, and logout from anywhere in the app.",
        icon: "user"
      },
      {
        title: "Help Widget",
        description: "Get instant help with FAQs, guides, and support options via the floating help button.",
        icon: "help-circle"
      },
      {
        title: "Onboarding Tours",
        description: "Step-by-step guidance for new users to discover key features and workflows.",
        icon: "compass"
      }
    ]
  }
];

export const getCurrentVersion = () => {
  return announcements[0]?.version || "1.0.0";
};
